import Pochta from "./Pochta";
function ISTP()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
            <div className="image-wrapper" >
     <img src="/img/ISTP Виртуоз.png" className="ISTP"/>
     </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
        <h2>ISTP</h2>
     <p><strong>Процент населения:</strong> 4–6%</p>
<p><strong>Среди мужчин:</strong> 6–9%</p>
<p><strong>Среди женщин:</strong> 2–4%</p>
<p><strong>Стратегия:</strong> Исследование и действие</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  ISTP черпают энергию в одиночестве и практической деятельности. 
  Им нужно время, чтобы изучить механизмы и понять, как всё работает. 
  Они восстанавливают силы, занимаясь своими руками или исследуя новое.
</p>
<p>
  Решения ISTP принимают на основе логики и практического опыта. 
  Они доверяют своим навыкам и быстрой реакции. 
  Они ценят свободу, независимость и возможность действовать.
</p>
<p>
  Это наблюдательные и изобретательные люди. 
  Они всегда знают, как починить или улучшить что-либо. 
  Им трудно следовать правилам, но их изобретательность поражает.
</p>

<p><strong>Особенность:</strong></p>
<p>
  ISTP — это одиночка, который не нуждается в тебе. Они общаются только по делу, 
  не проявляют эмоций и могут исчезнуть на неделю, не предупредив. 
  Им трудно поддерживать длительные отношения, и они быстро теряют интерес.
</p>

<p>
  ISTP — это человек, который может починить всё, что сломано, и не сказать ни слова. 
  Они — мастера на все руки, которые живут настоящим моментом. 
  Их спокойствие в кризис — легендарно. Пока остальные паникуют, ISTP уже чинит двигатель.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default ISTP;